import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from "./utils/createTransform";
import {calendarLiturgicalTextSchema} from "./calendar";

export const godwordsSchema = new schema.Entity(
  'godwords',
  {},
  {
    idAttribute: 'idname',
  }
)

// Route::get('god-words/get-random-orders', 'GodWordController@getSuggestedWords');
export const godwords_getSuggestedWords_Api = {
  backend: `Route::get('god-words/get-random-orders', 'GodWordController@getSuggestedWords');`,
  root: API_ROOT_URL,
  path: '/god-words/get-random-orders',
  method: 'GET',
  fields: ['sort_by', 'keyword', 'limit', 'id', 'today', 'exclude_id', 'hashtags', 'timezone_offset_in_hours'],
  paramsFields: ['sort_by', 'keyword', 'limit', 'id', 'today', 'exclude_id', 'hashtags', 'timezone_offset_in_hours'],
  schema: godwordsSchema,
  transform: createListTransform(godwordsSchema),
}

// Route::get('god-words/gets', 'GodWordController@getWordsOfGod');
export const godwords_getWordsOfGod_Api = {
  backend: `Route::get('god-words/gets', 'GodWordController@getWordsOfGod');`,
  root: API_ROOT_URL,
  path: '/god-words/gets',
  method: 'GET',
  fields: ['sort_by', 'keyword', 'hashtags'],
  paramsFields: ['sort_by', 'keyword', 'hashtags'],
  schema: godwordsSchema,
  transform: createListTransform(godwordsSchema),
}

// Route::get('lookup/{type}/get-stats', 'LookupController@getStatsByType');
export const godwords_getStatsByTagCloud_Api = {
  backend: `Route::get('lookup/{type}/get-stats', 'LookupController@getStatsByType');`,
  root: API_ROOT_URL,
  path: '/lookup/god_word_hashtags/get-stats',
  method: 'GET'
}

// Route::post('god-words/god-word/create-new', 'GodWordController@createNew');
export const godwords_setPhoto_Api = {
  backend: `Route::post('god-words/god-word/:id/set-photo', 'GodWordController@setPhoto');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/:id/set-photo',
  method: 'POST',
  schema: godwordsSchema,
  transform: createTransform(godwordsSchema, 'data'),
}

// Route::post('god-words/god-word/create-new', 'GodWordController@createNew');
export const godwords_createNew_Api = {
  backend: `Route::post('god-words/god-word/create-new', 'GodWordController@createNew');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/create-new',
  method: 'POST',
  schema: godwordsSchema,
  transform: createTransform(godwordsSchema, 'data'),
}

// Route::post('god-words/god-word/{id}/delete', 'GodWordController@delete');
export const godwords_delete_Api = {
  backend: `Route::post('god-words/god-word/{id}/delete', 'GodWordController@delete');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/:id/delete',
  method: 'POST',
  schema: godwordsSchema,
  transform: createTransform(godwordsSchema, 'data'),
}

// Route::get('god-words/get-random-orders', 'GodWordController@getSuggestedWords');
export const godwords_update_Api = {
  backend: `Route::post('god-words/god-word/{id}/edit', 'GodWordController@update');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/:id/edit',
  method: 'POST',
  schema: godwordsSchema,
  transform: createTransform(godwordsSchema, 'data'),
}

// Route::get('god-words/get-random-orders', 'GodWordController@getSuggestedWords');
export const godwords_getById_Api = {
  backend: `Route::get('god-words/god-word/{id}/get', 'GodWordController@getById');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/:id/get',
  method: 'GET',
  schema: godwordsSchema,
  transform: createTransform(godwordsSchema, 'data'),
}

// Route::get('god-words/god-word/{id}/get-meditations', 'GodWordController@getMeditations');
export const godwords_getMeditations_Api = {
  backend: `Route::get('god-words/god-word/{id}/get-meditations', 'GodWordController@getMeditations');`,
  root: API_ROOT_URL,
  path: '/god-words/god-word/:id/get-meditations',
  method: 'GET',
  fields: [],
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createListTransform(calendarLiturgicalTextSchema),
};